import React, { Component } from 'react'
//import Botao from '../utils/Botao';

import './EspacoSmall.css';

class RestauranteSmall extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entity: {}
    };
  }

  entityClicked = () => {
    this.props.entityClicked(this.props.item.identifier);
  }

  render() {
    return (
      <div id="restauranteSmall" className="col-sm-6 col-md-4">
        <div onClick={this.entityClicked} id="restauranteSmallUnit" className="box-shadow">
          <div className="imagem-restaurante">

            <img src={this.props.item.mainPhoto} className="fit-image__restaurantes" alt="Imagem Restaurante" />
            
            <div className="elemento-restaurante">
              <p className="elemento-restaurante__titulo">{this.props.item.name}</p>
              {this.props.item.type && 
                <p className="elemento-restaurante__texto">
                  {this.props.item.type}
                </p>
              }
              
            </div>

          </div>

        </div>
      </div>
    )
  }
}

export default RestauranteSmall;
